import { defineStore } from 'pinia';

interface IRouteState {
  loadMorePath?: string;
  readArticles: number[];
}

interface IRoute {
  path?: string;
  position?: number;
  state?: IRouteState;
}

interface IState {
  routes: IRoute[];
}

// we use the history position (entry id) to match the path data, since paths can exist multiple times)
const useRoutesStore = defineStore('routes', {
  state: (): IState => {
    return {
      routes: [],
    };
  },
  actions: {
    setRouteData(path: string, articleId: number, articlePath?: string): void {
      const router = useRouter();
      const { position } = router.options.history.state;

      const currentIndex = this.$state.routes.findIndex(
        (route: IRoute) => route.path === path && route.position === position,
      );

      if (currentIndex !== -1) {
        // update
        const clonedItem = { ...this.$state.routes[currentIndex] };

        if (clonedItem.state) {
          clonedItem.state.loadMorePath = articlePath;
          clonedItem.state.readArticles.push(articleId);
          this.$state.routes[currentIndex] = clonedItem;
        }
      } else {
        // add
        this.$state.routes.push({
          path,
          position,
          state: {
            loadMorePath: articlePath,
            readArticles: [articleId],
          },
        });
      }
    },
    getPathState(path: string) {
      const router = useRouter();
      const { position } = router.options.history.state;

      return this.$state.routes.find(
        (route: IRoute) => route.path === path && route.position === position,
      )?.state;
    },
  },
});

export default useRoutesStore;
